import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitLayoutsDrawer.module.scss';

const Drawer = forwardRef(({
  className,
  children,
  placement,
  position,
  isActive,
  testId,
}, ref) => {
  // This is assuming we will eventually have position: top and bottom
  const PLACEMENT = {
    left: styles.isPlacementLeft,
    right: styles.isPlacementRight,
  };

  const POSITION = {
    absolute: styles.isPositionAbsolute,
    fixed: styles.isPositionFixed,
  };

  return (
    <div
      className={classnames(
        styles.element,
        {
          [styles.isActive]: isActive,
          [PLACEMENT[placement]]: placement,
          [POSITION[position]]: position,
        },
        className,
      )}
      aria-hidden={!isActive}
      data-testid={testId}
      ref={ref}
    >
      {children}
    </div>
  );
});

Drawer.displayName = 'Drawer';

Drawer.defaultProps = {
  children: null,
  className: '',
  placement: 'left',
  position: 'fixed',
  isActive: false,
  testId: '',
};

Drawer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  placement: PropTypes.string,
  position: PropTypes.string,
  isActive: PropTypes.bool,
  testId: PropTypes.string,
};

export default Drawer;
